import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const PathwayCard = ({ pathway, onEdit, onDelete, onCreateDraft, onManageVersions }) => {
  const { t } = useLanguage();
  const version = pathway.current_version || {};
  const isActive = pathway.is_active;

  return (
    <div className="p-6 hover:bg-gray-800/50 transition-colors duration-150 border-b border-gray-700 last:border-0">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-lg font-medium text-white">
            {pathway.pathway_key.replace('_', ' ').toUpperCase()}
          </h4>
          <div className="mt-2 flex items-center space-x-4 text-sm text-gray-400">
            <span>Base Cost: ${pathway.base_cost}</span>
            <span>Processing: {pathway.processing_days} days</span>
            <span>Success Rate: {pathway.success_rate}%</span>
          </div>
          <div className="mt-2 text-xs text-gray-400 space-x-3">
            <span>Slug: <code className="bg-gray-700 px-1 py-0.5 rounded text-gray-300">{pathway.slug}</code></span>
            <span>Version: {version.version_number || '—'} ({version.status || 'n/a'})</span>
            {version.published_at && <span>Published: {new Date(version.published_at).toLocaleDateString()}</span>}
            <span className={`px-2 py-0.5 rounded border ${isActive ? 'bg-emerald-900/30 text-emerald-400 border-emerald-800' : 'bg-gray-700 text-gray-300 border-gray-600'}`}>
              {isActive ? 'Active' : 'Inactive'}
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onManageVersions}
            className="p-2 text-indigo-400 hover:bg-indigo-900/30 rounded-lg transition-colors"
            title="Manage Versions"
          >
            Versions
          </button>
          <button
            onClick={onCreateDraft}
            className="p-2 text-purple-400 hover:bg-purple-900/30 rounded-lg transition-colors"
            title="Create Draft"
          >
            Draft
          </button>
          <button
            onClick={onEdit}
            className="p-2 text-blue-400 hover:bg-blue-900/30 rounded-lg transition-colors"
            title="Edit Pathway"
          >
            Edit
          </button>
          <button
            onClick={onDelete}
            className="p-2 text-red-400 hover:bg-red-900/30 rounded-lg transition-colors"
            title="Delete Pathway"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default PathwayCard;
